import { render, staticRenderFns } from "./VindiPlansSelect.vue?vue&type=template&id=33aa3dc3"
import script from "./VindiPlansSelect.vue?vue&type=script&lang=js"
export * from "./VindiPlansSelect.vue?vue&type=script&lang=js"
import style0 from "./VindiPlansSelect.vue?vue&type=style&index=0&id=33aa3dc3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports